export default "__VITE_ASSET__BK6_tjmi__"